import { toFormikValidationSchema } from "zod-formik-adapter";

import type { IShapeOfForm } from "@utils";
import { z } from "@utils";

export interface IAppointmentCommentValues {
  score: "1" | "2" | "3" | "4" | "5";
  comment: string;
}

export const AppointmentCommentInitialValues: IAppointmentCommentValues = {
  comment: "",
  score: "5",
};

export const AppointmentCommentSchema = toFormikValidationSchema(
  z.object<IShapeOfForm<IAppointmentCommentValues>>({
    comment: z.string(),
  }),
);
